import { useSelector } from "react-redux";
import { TextWrapper, Wrapper, TextWrapperSpan } from "../../../constants/common/StyledGlobalConstants";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

const TechnicianPOC = ({ technicianPOC, isReschedule }) => {
  const { contactName, name, email, phone } = technicianPOC;
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;

  const renderDetail = (label, value, margin = isMobile ? "1rem" : "4px") => (
    <TextWrapper marginTop={`${margin} !important`} lineHeight="1.25rem">
      <TextWrapperSpan fontWeight="700">{label}: </TextWrapperSpan>
      {isMobile ? <TextWrapper marginTop="0.5rem !important">{value}</TextWrapper> : <TextWrapperSpan marginLeft="0.5rem">{value}</TextWrapperSpan>}
    </TextWrapper>
  );

  return (
    <Wrapper marginTop={isMobile ? "1.5rem" : "2rem"}>
      <TextWrapper fontSize="1.5rem" fontWeight="700" lineHeight="2rem">
        Point of contact for technician
      </TextWrapper>
      <Wrapper marginTop="1rem" fontSize="0.875rem" fontWeight="400" border="1px solid #D8DADA" borderRadius="8px" lineHeight="1.375rem">
        <Wrapper padding="1.5rem">
          {renderDetail("Name", isReschedule ? name : contactName, 0)}
          {renderDetail("Email address", email)}
          {renderDetail("Phone number", phone ? "+1 " + phone : null)}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};

TechnicianPOC.propTypes = {
  technicianPOC: PropTypes.shape({
    contactName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  isReschedule: PropTypes.bool.isRequired,
};

export default TechnicianPOC;